import { getMovesForBishop } from './getMovesForBishop';
import { getMovesForRook } from './getMovesForRook';
const getMovesForQueen = (requiredContext) => {
    const diagonals = getMovesForBishop(requiredContext);
    const ranksAndFiles = getMovesForRook(requiredContext);
    const availableLocations = new Set([...diagonals, ...ranksAndFiles]);
    return availableLocations;
};
export { getMovesForQueen };
